import { LogLevel, type Configuration } from "@azure/msal-browser";

/**
 * MSAL configuration for Nested App Authentication (NAA) with Entra ID.
 * Values are injected at build time from env/{environment}.env via webpack DefinePlugin.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.AUTH_CLIENT_ID,
    redirectUri: process.env.AUTH_REDIRECT_URI,
    authority: `https://login.microsoftonline.com/${process.env.AUTH_TENANT_ID}`
  },
  cache: {
    cacheLocation: "localStorage",
  }
};

export const apiScopes = ["https://analysis.windows.net/powerbi/api/GraphQLApi.Execute.All"];
